// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_array from "rescript/lib/es6/caml_array.js";
import * as Ethers$SensumPwa from "../../blockchain/eth/ethers/Ethers.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Sensations$SensumPwa from "../../blockchain/eth/sensations/Sensations.bs.js";

function useSensations(config) {
  var match = React.useState(function () {
        return Ethers$SensumPwa.toBigInt(-1);
      });
  var setLastUnloadedIndex = match[1];
  var lastUnloadedIndex = match[0];
  var match$1 = React.useState(function () {
        return true;
      });
  var setLoading = match$1[1];
  var loading = match$1[0];
  var match$2 = React.useState(function () {
        return [];
      });
  var setSensations = match$2[1];
  var provider = Ethers$SensumPwa.getProvider(config.networkUrl);
  React.useEffect((function () {
          console.log("useSensations::config", config);
          Curry._1(setLoading, (function (param) {
                  return true;
                }));
          var p = async function (param) {
            try {
              var contract = Sensations$SensumPwa.getContract(config, provider);
              var sensationslength = await Sensations$SensumPwa.getSensationsLength(contract);
              console.log("useSensations::getSensationsLength", sensationslength);
              var sensationsIndex = Ethers$SensumPwa.subBigInt(sensationslength, Ethers$SensumPwa.toBigInt(1));
              console.log("useSensations::index", sensationslength);
              var indexes = Belt_Array.keep(Belt_Array.makeBy(10, (function (i) {
                          return Ethers$SensumPwa.subBigInt(sensationsIndex, Ethers$SensumPwa.toBigInt(i));
                        })), (function (i) {
                      return Ethers$SensumPwa.greaterOrEqualBigInt(i, Ethers$SensumPwa.toBigInt(0));
                    }));
              var results = Promise.all(Belt_Array.map(indexes, (function (index) {
                          return Sensations$SensumPwa.getSensationByIndex(contract, index);
                        })));
              var sensations = await results;
              console.log("useSensations::sensations", sensations);
              Curry._1(setSensations, (function (param) {
                      return sensations;
                    }));
              Curry._1(setLoading, (function (param) {
                      return false;
                    }));
              if (indexes.length !== 0) {
                return Curry._1(setLastUnloadedIndex, (function (param) {
                              return Ethers$SensumPwa.subBigInt(Caml_array.get(indexes, indexes.length - 1 | 0), Ethers$SensumPwa.toBigInt(1));
                            }));
              } else {
                return ;
              }
            }
            catch (raw_e){
              var e = Caml_js_exceptions.internalToOCamlException(raw_e);
              if (e.RE_EXN_ID === Js_exn.$$Error) {
                var msg = e._1.message;
                if (msg !== undefined) {
                  console.log("JS error thrown: " + msg);
                  return Curry._1(setLoading, (function (param) {
                                return false;
                              }));
                } else {
                  console.log("Some other exception has been thrown");
                  return Curry._1(setLoading, (function (param) {
                                return false;
                              }));
                }
              }
              throw e;
            }
          };
          p(undefined);
        }), [config]);
  var loadMore = function (param) {
    console.log("loadMore::lastLoadedIndex", lastUnloadedIndex);
    if (!(Ethers$SensumPwa.greaterOrEqualBigInt(lastUnloadedIndex, Ethers$SensumPwa.toBigInt(0)) && !loading)) {
      return ;
    }
    Curry._1(setLoading, (function (param) {
            return true;
          }));
    var p = async function (param) {
      try {
        var contract = Sensations$SensumPwa.getContract(config, provider);
        var indexes = Belt_Array.keep(Belt_Array.makeBy(5, (function (i) {
                    return Ethers$SensumPwa.subBigInt(lastUnloadedIndex, Ethers$SensumPwa.toBigInt(i));
                  })), (function (i) {
                return Ethers$SensumPwa.greaterOrEqualBigInt(i, Ethers$SensumPwa.toBigInt(0));
              }));
        var results = Promise.all(Belt_Array.map(indexes, (function (index) {
                    return Sensations$SensumPwa.getSensationByIndex(contract, index);
                  })));
        var sensations = await results;
        console.log("loadMore::sensations", sensations);
        Curry._1(setSensations, (function (prevSensations) {
                return Belt_Array.concat(prevSensations, sensations);
              }));
        Curry._1(setLoading, (function (param) {
                return false;
              }));
        return Curry._1(setLastUnloadedIndex, (function (param) {
                      return Ethers$SensumPwa.subBigInt(Caml_array.get(indexes, indexes.length - 1 | 0), Ethers$SensumPwa.toBigInt(1));
                    }));
      }
      catch (raw_e){
        var e = Caml_js_exceptions.internalToOCamlException(raw_e);
        if (e.RE_EXN_ID === Js_exn.$$Error) {
          var msg = e._1.message;
          if (msg !== undefined) {
            console.log("JS error thrown: " + msg);
            return Curry._1(setLoading, (function (param) {
                          return false;
                        }));
          } else {
            console.log("Some other exception has been thrown");
            return Curry._1(setLoading, (function (param) {
                          return false;
                        }));
          }
        }
        throw e;
      }
    };
    p(undefined);
  };
  return [
          match$2[0],
          loading,
          loadMore,
          lastUnloadedIndex
        ];
}

export {
  useSensations ,
}
/* react Not a pure module */
